import {ID_TOKEN} from '../consts';

import {JwtHelper} from './jwt-helper';

export function tokenNotExpired(tokenName: string = ID_TOKEN, jwt?: string): boolean {
  const token: string = jwt || localStorage.getItem(tokenName);
  const jwtHelper = new JwtHelper();
  return token != undefined && !jwtHelper.isTokenExpired(token);
}
